// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file file_upload.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file file_upload.proto.
 */
export const file_file_upload: GenFile = /*@__PURE__*/
  fileDesc("ChFmaWxlX3VwbG9hZC5wcm90bxIJcmFjY29vbmFpIugCCgpGaWxlVXBsb2FkEgoKAmlkGAEgAigEEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgCIAIoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkEgsKA3VybBgDIAIoCRInCgR0eXBlGAQgAigOMhkucmFjY29vbmFpLkZpbGVVcGxvYWRUeXBlEgsKA2xhdBgFIAEoAhILCgNsb24YBiABKAISFgoGam9iX2lkGAcgASgEUgZqb2JfaWQSIAoLY29udHJhY3RfaWQYCCABKARSC2NvbnRyYWN0X2lkEjoKCmNyZWF0ZWRfYXQYCSACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpjcmVhdGVkX2F0EhwKCWF1dGhvcl9pZBgKIAEoBFIJYXV0aG9yX2lkEgwKBG5hbWUYCyABKAkSJgoOY29udGFpbmVyX25hbWUYDCABKAlSDmNvbnRhaW5lcl9uYW1lIuMBChBGaWxlVXBsb2FkQ3JlYXRlEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgBIAIoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkEicKBHR5cGUYAiACKA4yGS5yYWNjb29uYWkuRmlsZVVwbG9hZFR5cGUSCwoDbGF0GAMgASgCEgsKA2xvbhgEIAEoAhIWCgZqb2JfaWQYBSABKARSBmpvYl9pZBIgCgtjb250cmFjdF9pZBgGIAEoBFILY29udHJhY3RfaWQSHAoJYXV0aG9yX2lkGAcgASgEUglhdXRob3JfaWQidQoERmlsZRINCgVieXRlcxgBIAEoCRIMCgRuYW1lGAIgASgJEg4KBmZvcm1hdBgDIAEoCRILCgNsYXQYBCABKAESCwoDbG9uGAUgASgBEiYKAnRzGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCrNBAoORmlsZVVwbG9hZFR5cGUSHgoaRklMRV9VUExPQURfVFlQRV9VTkRFRklORUQQABIoCiRGSUxFX1VQTE9BRF9UWVBFX0pPQl9TRVJWSUNFX1NUQVJURUQQARImCiJGSUxFX1VQTE9BRF9UWVBFX0pPQl9TRVJWSUNFX0VOREVEEAISKQolRklMRV9VUExPQURfVFlQRV9QSUNLVVBfTE9DQVRJT05fVklFVxADEiYKIkZJTEVfVVBMT0FEX1RZUEVfQ09OVFJBQ1RfRE9DVU1FTlQQBBInCiNGSUxFX1VQTE9BRF9UWVBFX1NDQUxFX1JFQ09SRF9QSE9UTxAFEiUKIUZJTEVfVVBMT0FEX1RZUEVfQ09OVEFJTkVSX0JFRk9SRRAGEiQKIEZJTEVfVVBMT0FEX1RZUEVfQ09OVEFJTkVSX0FGVEVSEAcSLgoqRklMRV9VUExPQURfVFlQRV9ST1VURV9UQVNLX0ZBSUxVUkVfUkVBU09OEAgSLAooRklMRV9VUExPQURfVFlQRV9TSVRVQVRJT05fUkVQT1JUX0JFRk9SRRAJEisKJ0ZJTEVfVVBMT0FEX1RZUEVfU0lUVUFUSU9OX1JFUE9SVF9BRlRFUhAKEikKJUZJTEVfVVBMT0FEX1RZUEVfU0lUVUFUSU9OX1JFUE9SVF9HUFMQCxIkCiBGSUxFX1VQTE9BRF9UWVBFX0pPQl9JTlNUUlVDVElPThAMEiQKIEZJTEVfVVBMT0FEX1RZUEVfRFJJVkVSX0lOQ0lERU5UEA1CBloELi9wYg", [file_google_protobuf_timestamp]);

/**
 * @generated from message raccoonai.FileUpload
 */
export type FileUpload = Message<"raccoonai.FileUpload"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string url = 3;
   */
  url: string;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 4;
   */
  type: FileUploadType;

  /**
   * @generated from field: optional float lat = 5;
   */
  lat: number;

  /**
   * @generated from field: optional float lon = 6;
   */
  lon: number;

  /**
   * @generated from field: optional uint64 job_id = 7 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional uint64 contract_id = 8 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 9 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional uint64 author_id = 10 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * @generated from field: optional string name = 11;
   */
  name: string;

  /**
   * @generated from field: optional string container_name = 12 [json_name = "container_name"];
   */
  containerName: string;
};

/**
 * @generated from message raccoonai.FileUpload
 */
export type FileUploadJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string url = 3;
   */
  url?: string;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 4;
   */
  type?: FileUploadTypeJson;

  /**
   * @generated from field: optional float lat = 5;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float lon = 6;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 job_id = 7 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional uint64 contract_id = 8 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 9 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 author_id = 10 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * @generated from field: optional string name = 11;
   */
  name?: string;

  /**
   * @generated from field: optional string container_name = 12 [json_name = "container_name"];
   */
  container_name?: string;
};

/**
 * Describes the message raccoonai.FileUpload.
 * Use `create(FileUploadSchema)` to create a new message.
 */
export const FileUploadSchema: GenMessage<FileUpload, {jsonType: FileUploadJson}> = /*@__PURE__*/
  messageDesc(file_file_upload, 0);

/**
 * @generated from message raccoonai.FileUploadCreate
 */
export type FileUploadCreate = Message<"raccoonai.FileUploadCreate"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 2;
   */
  type: FileUploadType;

  /**
   * @generated from field: optional float lat = 3;
   */
  lat: number;

  /**
   * @generated from field: optional float lon = 4;
   */
  lon: number;

  /**
   * @generated from field: optional uint64 job_id = 5 [json_name = "job_id"];
   */
  jobId: bigint;

  /**
   * @generated from field: optional uint64 contract_id = 6 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: optional uint64 author_id = 7 [json_name = "author_id"];
   */
  authorId: bigint;
};

/**
 * @generated from message raccoonai.FileUploadCreate
 */
export type FileUploadCreateJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required raccoonai.FileUploadType type = 2;
   */
  type?: FileUploadTypeJson;

  /**
   * @generated from field: optional float lat = 3;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional float lon = 4;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 job_id = 5 [json_name = "job_id"];
   */
  job_id?: string;

  /**
   * @generated from field: optional uint64 contract_id = 6 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: optional uint64 author_id = 7 [json_name = "author_id"];
   */
  author_id?: string;
};

/**
 * Describes the message raccoonai.FileUploadCreate.
 * Use `create(FileUploadCreateSchema)` to create a new message.
 */
export const FileUploadCreateSchema: GenMessage<FileUploadCreate, {jsonType: FileUploadCreateJson}> = /*@__PURE__*/
  messageDesc(file_file_upload, 1);

/**
 * @generated from message raccoonai.File
 */
export type File = Message<"raccoonai.File"> & {
  /**
   * base64-encoded image data
   *
   * @generated from field: optional string bytes = 1;
   */
  bytes: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name: string;

  /**
   * e.g., jpg, png
   *
   * @generated from field: optional string format = 3;
   */
  format: string;

  /**
   * @generated from field: optional double lat = 4;
   */
  lat: number;

  /**
   * @generated from field: optional double lon = 5;
   */
  lon: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp ts = 6;
   */
  ts?: Timestamp;
};

/**
 * @generated from message raccoonai.File
 */
export type FileJson = {
  /**
   * base64-encoded image data
   *
   * @generated from field: optional string bytes = 1;
   */
  bytes?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * e.g., jpg, png
   *
   * @generated from field: optional string format = 3;
   */
  format?: string;

  /**
   * @generated from field: optional double lat = 4;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double lon = 5;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Timestamp ts = 6;
   */
  ts?: TimestampJson;
};

/**
 * Describes the message raccoonai.File.
 * Use `create(FileSchema)` to create a new message.
 */
export const FileSchema: GenMessage<File, {jsonType: FileJson}> = /*@__PURE__*/
  messageDesc(file_file_upload, 2);

/**
 * @generated from enum raccoonai.FileUploadType
 */
export enum FileUploadType {
  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_JOB_SERVICE_STARTED = 1;
   */
  JOB_SERVICE_STARTED = 1,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_JOB_SERVICE_ENDED = 2;
   */
  JOB_SERVICE_ENDED = 2,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_PICKUP_LOCATION_VIEW = 3;
   */
  PICKUP_LOCATION_VIEW = 3,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_CONTRACT_DOCUMENT = 4;
   */
  CONTRACT_DOCUMENT = 4,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_SCALE_RECORD_PHOTO = 5;
   */
  SCALE_RECORD_PHOTO = 5,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_CONTAINER_BEFORE = 6;
   */
  CONTAINER_BEFORE = 6,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_CONTAINER_AFTER = 7;
   */
  CONTAINER_AFTER = 7,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_ROUTE_TASK_FAILURE_REASON = 8;
   */
  ROUTE_TASK_FAILURE_REASON = 8,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_SITUATION_REPORT_BEFORE = 9;
   */
  SITUATION_REPORT_BEFORE = 9,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_SITUATION_REPORT_AFTER = 10;
   */
  SITUATION_REPORT_AFTER = 10,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_SITUATION_REPORT_GPS = 11;
   */
  SITUATION_REPORT_GPS = 11,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_JOB_INSTRUCTION = 12;
   */
  JOB_INSTRUCTION = 12,

  /**
   * @generated from enum value: FILE_UPLOAD_TYPE_DRIVER_INCIDENT = 13;
   */
  DRIVER_INCIDENT = 13,
}

/**
 * @generated from enum raccoonai.FileUploadType
 */
export type FileUploadTypeJson = "FILE_UPLOAD_TYPE_UNDEFINED" | "FILE_UPLOAD_TYPE_JOB_SERVICE_STARTED" | "FILE_UPLOAD_TYPE_JOB_SERVICE_ENDED" | "FILE_UPLOAD_TYPE_PICKUP_LOCATION_VIEW" | "FILE_UPLOAD_TYPE_CONTRACT_DOCUMENT" | "FILE_UPLOAD_TYPE_SCALE_RECORD_PHOTO" | "FILE_UPLOAD_TYPE_CONTAINER_BEFORE" | "FILE_UPLOAD_TYPE_CONTAINER_AFTER" | "FILE_UPLOAD_TYPE_ROUTE_TASK_FAILURE_REASON" | "FILE_UPLOAD_TYPE_SITUATION_REPORT_BEFORE" | "FILE_UPLOAD_TYPE_SITUATION_REPORT_AFTER" | "FILE_UPLOAD_TYPE_SITUATION_REPORT_GPS" | "FILE_UPLOAD_TYPE_JOB_INSTRUCTION" | "FILE_UPLOAD_TYPE_DRIVER_INCIDENT";

/**
 * Describes the enum raccoonai.FileUploadType.
 */
export const FileUploadTypeSchema: GenEnum<FileUploadType, FileUploadTypeJson> = /*@__PURE__*/
  enumDesc(file_file_upload, 0);

